export default __webpack_public_path__ + "static/media/s.b53aa8fc.jpg";